import { createTheme } from '@mui/material';

const baseTheme = {
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        },
      },
    },
  },
};

export const lightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
      dark: '#115293',
      light: '#4791db',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#dc004e',
      dark: '#9a0036',
      light: '#e33371',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
      gradient: 'linear-gradient(135deg, #1976d2 0%, #115293 100%)',
    },
    text: {
      primary: '#1c1e21',
      secondary: '#65676b',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    action: {
      active: '#1976d2',
      hover: 'rgba(25, 118, 210, 0.08)',
      selected: 'rgba(25, 118, 210, 0.16)',
      disabled: 'rgba(0, 0, 0, 0.26)',
      disabledBackground: 'rgba(0, 0, 0, 0.12)',
    },
  },
});

export const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
      dark: '#64b5f6',
      light: '#bbdefb',
      contrastText: '#1c1e21',
    },
    secondary: {
      main: '#f48fb1',
      dark: '#f06292',
      light: '#f8bbd0',
      contrastText: '#1c1e21',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
      gradient: 'linear-gradient(135deg, #90caf9 0%, #64b5f6 100%)',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0b8c1',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    action: {
      active: '#90caf9',
      hover: 'rgba(144, 202, 249, 0.08)',
      selected: 'rgba(144, 202, 249, 0.16)',
      disabled: 'rgba(255, 255, 255, 0.3)',
      disabledBackground: 'rgba(255, 255, 255, 0.12)',
    },
  },
}); 